import { ContentType } from '@insided/shared/utils/contentType'
import { Author } from '../interfaces'
import Approve from './Approve'
import Button from '@insided/control/uikit/Button'
import { EscalationOptions } from '../Escalation'
import { MoveToTopic } from '../MoveToTopic'
import { ConfigContext } from '../utils'

export interface PostActionsProps {
  topicId: number
  contentType: ContentType
  author: Author
  title: string
  content: string | null
  trashed: boolean
  pending: boolean
  destinationUrl: string
  userId?: string
  isProductboardNoteCreationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
  isIntercomCreateConversationEnabled: boolean
  onShowEditor: () => void
  onApprove: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  publicId: string
  visibleReplyCount?: number | null
}

const OpeningPostActions = (props: PostActionsProps) => {
  const {
    title,
    userId,
    content,
    onShowEditor,
    onApprove,
    onShowAlert,
    destinationUrl,
    author,
    topicId,
    contentType,
    trashed,
    isProductboardNoteCreationEnabled,
    isSalesforceCaseEscalationEnabled,
    isZendeskTicketEscalationEnabled,
    isFreshdeskTicketEscalationEnabled,
    isIntercomCreateConversationEnabled,
    pending,
    publicId,
    visibleReplyCount
  } = props
  return (
    <ConfigContext.Consumer>
      {({ contentTypeConfig }) => {
        return (
          <div className='topic-moderation__post-actions'>
            <Button
              title='Edit post'
              variant='secondary'
              onClick={onShowEditor}
              data-qa='edit-post'
            />
            <EscalationOptions
              isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
              isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
              isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
              isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
              isIntercomCreateConversationEnabled={isIntercomCreateConversationEnabled}
              trashed={trashed}
              userId={author.id}
              username={author.username}
              publicId={topicId}
              moderatorId={userId as string}
              title={title}
              content={content}
              isReply={false}
              contentType={contentType}
              destinationUrl={destinationUrl}
              topicId={topicId}
            />

            {contentTypeConfig.moveTopicToExistingTopic && !trashed &&
              <MoveToTopic
                contentType={contentType}
                topicId={topicId}
                onShowAlert={onShowAlert}
                publicId={publicId}
                visibleReplyCount={visibleReplyCount}
              />}

            {pending &&
              <Approve
                topicId={topicId}
                contentType={contentType}
                onApprove={onApprove}
                onShowAlert={onShowAlert}
              />}
          </div>
        )
      }}
    </ConfigContext.Consumer>
  )
}

export default OpeningPostActions
